import { useState } from 'react';
import LanguagePicker from './LanguagePicker';
import Footer from './Footer';
import type { Lang, TranslationKey } from '../i18n';

export type LegalPage = 'mentions' | 'privacy' | 'cgv';

interface Props {
  lang: Lang;
  onChangeLang: (lang: Lang) => void;
  onGoogleClick: () => void;
  authError?: string;
  t: (key: TranslationKey, vars?: Record<string, string>) => string;
  priceLabel: string;
  domain: string;
  assetBase: string;
  onLegalClick?: (page: LegalPage) => void;
}

const Pricing = ({ lang, onChangeLang, onGoogleClick, authError, t, priceLabel, domain, assetBase, onLegalClick }: Props) => {
  const [imageLoaded, setImageLoaded] = useState(false);


  return (
    <div className="public-shell">
      <header className="public-topbar">
        <div className="public-brand">
          <img src="/logo-light.svg" alt="ShortURL" className="brand-logo brand-logo-light" />
          <img src="/logo-dark.svg" alt="ShortURL" className="brand-logo brand-logo-dark" />
        </div>

        <div className="public-actions">
          <LanguagePicker value={lang} onChange={onChangeLang} compact />
          <button className="primary outline" type="button" onClick={onGoogleClick}>
            {t('nav.signIn')}
          </button>
        </div>
      </header >

      <main className="pricing">
        <section className="pricing-hero">
          <div className="gridlines" />
          <div className="pricing-hero-copy">

            <h1>{t('pricing.title')}</h1>
            <p
              className="pricing-subtitle"
              dangerouslySetInnerHTML={{ __html: t('pricing.subtitle', { domain }) }}
            />
            <div className="hero-input-group">
              <input
                type="text"
                className="hero-input"
                placeholder={t('hero.inputPlaceholder')}
                readOnly
                onClick={onGoogleClick}
              />
              <button className="primary hero-button" type="button" onClick={onGoogleClick}>
                {t('hero.shortenButton')}
              </button>
            </div>
            <p className="hero-trust" dangerouslySetInnerHTML={{ __html: t('hero.noCreditCard') }} />
            <div className="hero-badges-wrapper">
              <div className="hero-badges">
                <div className="hero-badge">
                  <span className="badge-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" /><path d="M3 3v5h5" /><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" /><path d="M16 21h5v-5" /></svg>
                  </span>
                  <span>{t('hero.badge.editable')}</span>
                </div>
                <div className="hero-badge">
                  <span className="badge-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="4.93" y1="4.93" x2="19.07" y2="19.07" /></svg>
                  </span>
                  <span>{t('hero.badge.noAds')}</span>
                </div>
                <div className="hero-badge">
                  <span className="badge-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>
                  </span>
                  <span>{t('hero.badge.fast')}</span>
                </div>
                <div className="hero-badge">
                  <span className="badge-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
                  </span>
                  <span>{t('hero.badge.secure')}</span>
                </div>
                {/* Duplicate for infinite scroll effect on mobile */}
                <div className="hero-badge" aria-hidden="true">
                  <span className="badge-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" /><path d="M3 3v5h5" /><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" /><path d="M16 21h5v-5" /></svg>
                  </span>
                  <span>{t('hero.badge.editable')}</span>
                </div>
                <div className="hero-badge" aria-hidden="true">
                  <span className="badge-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="4.93" y1="4.93" x2="19.07" y2="19.07" /></svg>
                  </span>
                  <span>{t('hero.badge.noAds')}</span>
                </div>
                <div className="hero-badge" aria-hidden="true">
                  <span className="badge-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>
                  </span>
                  <span>{t('hero.badge.fast')}</span>
                </div>
                <div className="hero-badge" aria-hidden="true">
                  <span className="badge-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
                  </span>
                  <span>{t('hero.badge.secure')}</span>
                </div>
              </div>
            </div>
            {authError ? <p className="auth-error">{authError}</p> : null}

          </div>
          <div className="pricing-hero-art" aria-hidden="true">
            <div className="glow" />
          </div>
        </section>

        <section className="pricing-showcase">
          <div className="showcase-frame browser-frame" aria-label={t('pricing.exampleTitle')}>
            <div className="browser-header">
              <div className="browser-dots">
                <div className="browser-dot dot-red" />
                <div className="browser-dot dot-yellow" />
                <div className="browser-dot dot-green" />
              </div>
            </div>
            <div className="browser-content">
              <img
                className="showcase-image"
                src={`${assetBase}/shorturl-preview.png`}
                alt=""
                onLoad={() => setImageLoaded(true)}
                onError={() => setImageLoaded(false)}
                style={{ opacity: imageLoaded ? 1 : 0 }}
              />
              {!imageLoaded ? <div className="showcase-placeholder">shorturl-preview.png</div> : null}
            </div>
          </div>
        </section>

        <section className="pricing-cards" aria-label={t('pricing.plansLabel')}>
          <article className="pricing-card featured">
            <header className="pricing-card-header">
              <div className="featured-badge">{t('pricing.bestValue')}</div>
              <h2>{t('pricing.freeTitle')}</h2>
              <p className="pricing-card-price">
                <span className="price-amount">{t('pricing.freePrice')}</span>
                <span className="price-period">{t('pricing.freePeriod')}</span>
              </p>
              <p className="pricing-card-lede">{t('pricing.freeLede')}</p>
            </header>
            <ul className="pricing-list">
              <li>{t('pricing.freeFeature1')}</li>
              <li dangerouslySetInnerHTML={{ __html: t('pricing.freeFeatureSlug') }} />
              <li dangerouslySetInnerHTML={{ __html: t('pricing.freeFeatureModify') }} />
              <li className="feature-highlight">{t('pricing.analyticsTitle')}</li>
              <li className="feature-highlight">{t('pricing.qrCodeTitle')}</li>
              <li className="feature-highlight">{t('pricing.passwordTitle')}</li>
            </ul>
            <button className="secondary" type="button" onClick={onGoogleClick}>
              {t('pricing.freeCta')}
            </button>
          </article>

          <article className="pricing-card">
            <header className="pricing-card-header">
              <h2>{t('pricing.proTitle')}</h2>
              <p className="pricing-card-price">
                <span className="price-amount">{priceLabel}</span>
                <span className="price-period">{t('pricing.proPeriod')}</span>
              </p>
              <p className="pricing-card-lede">{t('pricing.proLede')}</p>
            </header>
            <ul className="pricing-list">
              <li><strong>{t('pricing.proFeature1')}</strong></li>
            </ul>
            <button className="primary" type="button" onClick={onGoogleClick}>
              {t('pricing.proCtaAlt')}
            </button>
            <p className="tiny muted">{t('pricing.proNote')}</p>
          </article>
        </section>

        <section className="pricing-faq">
          <h2>{t('pricing.faqTitle')}</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>{t('pricing.faqQ1')}</h3>
              <p className="muted">{t('pricing.faqA1')}</p>
            </div>
            <div className="faq-item">
              <h3>{t('pricing.faqQ2')}</h3>
              <p className="muted">{t('pricing.faqA2')}</p>
            </div>
            <div className="faq-item">
              <h3>{t('pricing.faqQ3')}</h3>
              <p className="muted">{t('pricing.faqA3')}</p>
            </div>
            <div className="faq-item">
              <h3>{t('pricing.faqQ4')}</h3>
              <p className="muted">{t('pricing.faqA4')}</p>
            </div>
          </div>
        </section>
      </main>

      <Footer t={t} onLegalClick={onLegalClick} />
    </div >
  );
};

export default Pricing;
